import { render, staticRenderFns } from "./Detalle-imputacion-proveedor.vue?vue&type=template&id=49c03d86"
import script from "./Detalle-imputacion-proveedor.vue?vue&type=script&lang=js"
export * from "./Detalle-imputacion-proveedor.vue?vue&type=script&lang=js"
import style0 from "./Detalle-imputacion-proveedor.vue?vue&type=style&index=0&id=49c03d86&prod&lang=css"
import style1 from "./Detalle-imputacion-proveedor.vue?vue&type=style&index=1&id=49c03d86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports